<template>
  <v-app dark>
    <!-- <img id="main-img" src="/bg2.webp" alt="" /> -->
    <v-app-bar
      v-if="!showHideSpinner"
      color="transparent"
      class="pro-card g-glossy"
      app
    >
      <v-toolbar-title
        class="my-name"
        @click="handleClick('home')"
        v-text="title"
      />
      <v-spacer />
      <fa
        height="40"
        width="40"
        class="text-white hover:cursor-pointer text-3xl icon-show"
        :icon="['fas', 'bars']"
        @click="drawer = true"
      ></fa>

      <nav class="nav-show">
        <ul>
          <li class="px-4" @click="handleClick('projects')">
            <span>Projects</span>
          </li>
          <li class="px-4" @click="handleClick('about-me')">
            <span>About me</span>
          </li>
          <li class="px-4" @click="handleClick('skills')">
            <span>Skills</span>
          </li>
          <li class="px-4">
            <nuxt-link to="/contact">Contact</nuxt-link>
          </li>
          <!-- <li class="px-4">
            <nuxt-link to="/resume">Resume</nuxt-link>
          </li> -->
        </ul>
      </nav>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" style="z-index: 1000" fixed temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class=" yellow--text text--accent-2"
        >
          <v-list-item
            active-class=" yellow--text text--accent-2"
            to="#"
            @click="handleClick('home')"
          >
            <v-list-item-icon>
              <fa
                height="28"
                width="28"
                class="text-white hover:cursor-pointer h-6 w-6 text-3xl"
                :icon="['fas', 'home']"
              ></fa>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item
            active-class=" yellow--text text--accent-2"
            to="#"
            @click="handleClick('projects')"
          >
            <v-list-item-icon>
              <fa
                height="28"
                width="28"
                class="text-white hover:cursor-pointer h-6 w-6 text-3xl"
                :icon="['fas', 'toolbox']"
              ></fa>
            </v-list-item-icon>
            <v-list-item-title>Projects</v-list-item-title>
          </v-list-item>
          <v-list-item
            active-class=" yellow--text text--accent-2"
            to="#"
            @click="handleClick('about-me')"
          >
            <v-list-item-icon>
              <fa
                height="28"
                width="28"
                class="text-white hover:cursor-pointer h-6 w-6 text-3xl"
                :icon="['fas', 'question-circle']"
              ></fa>
            </v-list-item-icon>
            <v-list-item-title>About me</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item active-class=" yellow--text text--accent-2" to="/resume">
            <v-list-item-icon>
              <fa
                height="28"
                width="28"
                class="text-white hover:cursor-pointer h-6 w-6 text-3xl"
                :icon="['fas', 'folder']"
              ></fa>
            </v-list-item-icon>
            <v-list-item-title>Resume</v-list-item-title>
          </v-list-item> -->
          <v-list-item
            active-class=" yellow--text text--accent-2"
            to="/contact"
          >
            <v-list-item-icon>
              <fa
                height="28"
                width="28"
                class="text-white hover:cursor-pointer h-6 w-6 text-3xl"
                :icon="['fas', 'phone']"
              ></fa>
            </v-list-item-icon>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      fab
      fixed
      bottom
      right
      class="pro-card"
      @click="scroll"
    >
      <fa
        height="40"
        width="40"
        class="text-white hover:cursor-pointer text-2xl"
        :icon="['fas', 'angle-up']"
      ></fa>
    </v-btn>
    <!-- <canvas id="bg"></canvas> -->
    <LoadingSpinner v-if="showHideSpinner"></LoadingSpinner>
    <img
      src="/bg2.webp"
      style="
        position: fixed;
        top: 0;
        left: 0;
        z-index: -10;
        height: 100%;
        width: 100%;
        object-fit: cover;
      "
      alt="main background"
      @load="showHideSpinner = false"
    />
    <!-- <v-main> -->
    <v-container id="v-cont" class="max-w-[1700px] mx-auto" fluid>
      <Nuxt />
    </v-container>
    <!-- </v-main> -->

    <v-footer color="transparent" class="pro-card">
      <v-card color="transparent" class="flex flex-col text-center" flat tile>
        <p class="text-h6 mt-3">Connect with me on social networks!</p>
        <div class="flex justify-center my-3">
          <a
            class="mx-2"
            target="blank"
            href="https://www.linkedin.com/in/adnan-kreiker/"
            ><img
              loading="lazy"
              height="40"
              width="40"
              class="swing my-0"
              src="/linkedin.9e3927c.svg"
              alt=""
          /></a>
          <a class="mx-2" target="blank" href="https://github.com/Adnan-kreiker"
            ><img
              loading="lazy"
              height="40"
              width="40"
              class="swing my-0"
              src="/github.2536ea4.svg"
              alt=""
          /></a>
        </div>

        <v-card-text class="my-2 white--text text-center">
          {{ new Date().getFullYear() }} — <strong>Adnan Kreiker</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>


<script>
import Tracker from '@openreplay/tracker/cjs'
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { MeshLambertMaterial } from 'three/src/materials/MeshLambertMaterial'
// import { TorusBufferGeometry } from 'three/src/geometries/TorusGeometry'
// import { SphereBufferGeometry } from 'three/src/geometries/SphereGeometry'
// import { MeshBasicMaterial } from 'three/src/materials/MeshBasicMaterial'
//  import { MeshStandardMaterial } from 'three/src/materials/MeshStandardMaterial'
// import { PerspectiveCamera } from 'three/src/cameras/PerspectiveCamera'
// import { WebGLRenderer } from 'three/src/renderers/WebGLRenderer'
// import { AmbientLight } from 'three/src/lights/AmbientLight'
// import { PointLight } from 'three/src/lights/PointLight'
// import { Mesh } from 'three/src/objects/Mesh'
// import { Scene } from 'three/src/scenes/Scene'
// import { TextureLoader } from 'three/src/loaders/TextureLoader'
// import { randFloatSpread } from 'three/src/math/MathUtils'
// import { LinearFilter } from 'three/src/constants'
import LoadingSpinner from '~/components/LoadingSpinner.vue'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

export default {
  components: { LoadingSpinner },
  data() {
    return {
      showHideSpinner: true,
      fixed: false,
      fab: false,
      drawer: false,
      group: null,
      title: 'Adnan Kreiker',
      footerLazy: false,
    }
  },
  head() {
    return {
      title: 'Adnan Kreiker',
      htmlAttrs: {
        lang: 'en',
      },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          hid: 'description',
          name: 'description',
          content: 'Adnan Kreiker - Portfolio',
        },
        { name: 'format-detection', content: 'telephone=no' },
      ],
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: '/bg2.webp',
        },
      ],
    }
  },
  beforeCreate() {
    this.showHideSpinner = true
  },
  mounted() {
    // const scene = new Scene()
    // const spaceTexture = new TextureLoader().load('/bg2.webp', () => {
    //   this.showHideSpinner = false
    // })
    // spaceTexture.minFilter = LinearFilter
    // scene.background = spaceTexture
    // const camera = new PerspectiveCamera(
    //   75,
    //   window.innerWidth / window.innerHeight,
    //   0.1,
    //   1000
    // )
    // function onResize() {
    //   camera.aspect = window.innerWidth / window.innerHeight
    //   camera.updateProjectionMatrix()
    //   renderer.setSize(window.innerWidth, window.innerHeight)
    // }
    // const pixelRatio = window.devicePixelRatio
    // let AA = true
    // if (pixelRatio > 1) {
    //   AA = false
    // }
    // window.addEventListener('resize', onResize)
    // const renderer = new WebGLRenderer({
    //   canvas: document.querySelector('#bg'),
    //   antialias: AA,
    //   alpha: true,
    //   powerPreference: 'high-performance',
    // })
    // // renderer.setClearColor(0xffffff, 0)
    // renderer.setPixelRatio(window.devicePixelRatio)
    // renderer.setSize(window.innerWidth, window.innerHeight)
    // camera.position.setZ(30)
    // renderer.render(scene, camera)
    // // CREATING THE TORUS
    // if (window.innerWidth > 1100) {
    //   const geometry = new TorusBufferGeometry(8, 1, 16, 100)
    //   const material = new MeshLambertMaterial({
    //     color: 1056049,
    //   })
    //   const torus = new Mesh(geometry, material)
    //   torus.position.x = 20
    //   scene.add(torus)
    //   const pointLight = new PointLight(16777215, 2)
    //   pointLight.position.set(50, 50, 50)
    //   const ambientLight = new AmbientLight(16777215, 1)
    //   scene.add(pointLight, ambientLight)
    //   // CREATING THE STARS
    //   function addStar() {
    //     const geometry = new SphereBufferGeometry(0.25, 12, 12)
    //     const material = new MeshBasicMaterial({
    //       color: 16777215,
    //     })
    //     const star = new Mesh(geometry, material)
    //     const [x, y, z] = Array(3)
    //       .fill()
    //       .map(() => randFloatSpread(100))
    //     star.position.set(x, y, z)
    //     scene.add(star)
    //   }
    //   Array(50).fill().forEach(addStar)
    //   // CREATING THE PLANET
    //   // const planetTexture = new TextureLoader().load(
    //   //   require('~/assets/venus.webp')
    //   // )
    //   // planetTexture.minFilter = LinearFilter
    //   // const planet = new Mesh(
    //   //   new SphereBufferGeometry(3, 32, 32),
    //   //   new MeshStandardMaterial({
    //   //     map: planetTexture,
    //   //   })
    //   // )
    //   // scene.add(planet)
    //   // planet.position.z = 25
    //   // planet.position.setX(-15)
    //   function moveCamera() {
    //     const t = document.body.getBoundingClientRect().top
    //     camera.position.z = t * -0.01
    //     camera.position.x = t * -0.0002
    //     camera.position.y = t * -0.0002
    //   }
    //   document.body.onscroll = moveCamera
    //   // THE VUE LOGO
    //   const loader = new GLTFLoader()
    //   loader.load('/logo_vue.glb', function (gltf) {
    //     gltf.scene.scale.set(50, 50, 50)
    //     gltf.scene.position.x = 20
    //     gltf.scene.position.y = 0
    //     gltf.scene.position.z = -10
    //     scene.add(gltf.scene)
    //   })
    //   function animate() {
    //     requestAnimationFrame(animate)
    //     torus.rotation.x += 0.001
    //     torus.rotation.y += 0.001
    //     torus.rotation.z += 0.001
    //     // planet.rotation.x += 0.001
    //     // planet.rotation.y += 0.001
    //     // planet.rotation.z += 0.001
    //     renderer.render(scene, camera)
    //   }
    //   animate()
    // } else {
    //   function animate2() {
    //     requestAnimationFrame(animate2)
    //     renderer.render(scene, camera)
    //   }
    //   animate2()
    // }
    window.onNuxtReady((app) => {
      const tracker = new Tracker({
        projectKey: `${process.env.NUXT_ENV_PROJECT_KEY}`,
      })
      tracker.start()
    })
  },
  beforeDestroy() {
    this.tracker.stop()
  },
  destroyed() {
    removeEventListener('resize', this.onResize)
  },

  methods: {
    handleClick(hashe) {
      this.$router.push({ name: 'index', hash: `#${hashe}` }, undefined, () => {
        location.href = this.$route.hash
      })
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    scroll() {
      window.scrollTo(0, 0)
    },
  },
  PageTransition: 'fade',
}
</script>

<style lang="scss" scoped>
#v-cont {
  margin-inline: auto !important;
}
* {
  box-sizing: border-box;
}
.my-name {
  cursor: pointer;
}
.icon-show {
  display: none;
}

@media (min-width: 960px) {
  .container {
    max-width: 100%;
  }
}
@media (max-width: 750px) {
  .icon-show {
    display: inline;
  }
  .nav-show {
    display: none;
  }
}
.container {
  margin: 0px !important;
  padding: 0px;
}
ul {
  list-style-type: none;
}

ul li {
  display: inline-block;
}

li:hover {
  cursor: pointer;
}
a {
  text-decoration: none;
  color: white;
}
li > span:after,
li > a:after {
  display: block;
  content: '';
  border-bottom: 2px solid rgb(207, 18, 188);
  transform: scaleX(0);
  transition: transform 350ms ease-in-out;
}
li > span:hover,
li > a:hover {
  color: rgba(190, 16, 172, 1);
  // font-weight: bold;
}
li > span:hover:after,
li > a:hover:after {
  transform: scaleX(1);
}
@-webkit-keyframes swing {
  15% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
  }
  30% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  50% {
    -webkit-transform: translateY(3px);
    transform: translateY(3px);
  }
  65% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
  80% {
    -webkit-transform: translateY(2px);
    transform: translateY(2px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes swing {
  15% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
  }
  30% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  50% {
    -webkit-transform: translateY(3px);
    transform: translateY(3px);
  }
  65% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
  80% {
    -webkit-transform: translateY(2px);
    transform: translateY(2px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.swing:hover {
  -webkit-animation: swing 1s ease;
  animation: swing 1s ease;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  border-radius: 100%;
  border: 1px solid rgba(190, 16, 172, 1);
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
}
.pro-card {
  background: rgba(0, 0, 0, 0.7);
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12);
}

@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
  .pro-card {
    -webkit-backdrop-filter: blur(10px);
    -moz-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}
#main-img {
  position: fixed;
  top: 0;
  left: 0;

  /* Preserve aspet ratio */
  min-width: 100%;
  min-height: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 100%;
  }
}
</style>
